import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Required Documentation\n          ", -1);
const _hoisted_4 = {
    key: 0,
    class: "text-blue-500 mt-4"
};
const _hoisted_5 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_6 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FileUploader = _resolveComponent("FileUploader");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                    _hoisted_3,
                    _createTextVNode(),
                    (!_ctx.showApprovalSteps)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "\n            * Please ensure that all documents are uploaded including a valid and complete Job Description.\n          "))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                _createVNode(_component_FileUploader, {
                    name: "form-eleven",
                    disabled: _ctx.showApprovalSteps,
                    files: _ctx.formData.files,
                    "document-short-id": _ctx.shortId,
                    uploading: _ctx.uploading,
                    onUpdateFiles: _ctx.handleUpdateFiles,
                    onFileUploading: _cache[0] || (_cache[0] = ($event) => (_ctx.uploading = $event))
                }, null, 8, ["disabled", "files", "document-short-id", "uploading", "onUpdateFiles"])
            ]),
            _createTextVNode(),
            (!_ctx.showApprovalSteps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("button", {
                        class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                    }, "\n          Reset Form\n        "),
                    _createTextVNode(),
                    _createElementVNode("button", {
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed",
                        disabled: _ctx.disableNext || _ctx.uploading,
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                    }, "\n          Next\n        ", 8, _hoisted_6)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
